<template>
  <div v-if="analytic" class="gp-content">
    <content-tab-bar :tabs="tabs"></content-tab-bar>
    <transition name="fade" mode="out-in">
      <router-view :analytic="analytic" :admin="true"></router-view>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ContentTabBar from '@/components/ContentTabBar.vue';

export default {
  name: 'AnalyticAdmin',
  components: { ContentTabBar },
  computed: {
    ...mapState('admin', ['analytic']),
    ...mapState('route', ['name']),
    tabs() {
      return [
        {
          label: 'Summary',
          link: {
            name: 'admin.analytics.index.detail',
            params: { id: this.analytic.uuid },
          },
          icon: 'logic',
        },
        {
          label: 'Edit',
          link: {
            name: 'admin.analytics.index.detail.edit',
            params: { id: this.analytic.uuid },
          },
          icon: 'edit',
        },
        {
          label: 'Delete',
          link: {
            name: 'admin.analytics.index.detail.delete',
            params: { id: this.analytic.uuid },
          },
          icon: 'delete',
        },
      ];
    },
  },
  async beforeMount() {
    await this.$store.dispatch('admin/getAnalytic', {
      uuid: this.$route.params.id,
    });
  },
};
</script>
